import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { IInterestLevelLeads } from "src/Contexts/Leads/LeadsTypes";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { api } from "src/shared/setup/API/api";

export const useUpdateInterestLevel = () => {
  const { handleGetAlert } = useLayoutMainContext();

  const { setAttTable } = useConfigPageContext();

  const handleUpdateInterestLevel = async (
    id: string,
    level: IInterestLevelLeads
  ) => {
    api
      .patch(`/leads/${id}/interest-level`, {
        interestLevel: level,
      })
      .then((res) => {
        handleGetAlert({ message: res.data.message });
        setAttTable((attTable) => !attTable);
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      );
  };

  return { handleUpdateInterestLevel };
};
